import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useTenantSettings } from "stores/tenantSettings"

import { Guid, ITranslations } from "@/types"
import { getTranslation } from "utils/translations"

interface IGetConfigurationTextParams {
    mergeAssets: Record<Guid, boolean>
    printFeatures: Record<Guid, boolean>
    language: string | undefined
    articles: {
        articleId: Guid
        articleDescriptionTranslations: ITranslations
        articleFeatures?: ITranslations
        assets: {
            assetId: Guid | undefined
            isFixed: boolean
            lmid: string | undefined
            serialNumber: string | undefined
            assetFeatures?: ITranslations
        }[]
    }[]
}

export default function useConfigurationText() {
    const { t } = useTranslation()
    const { tenantPrimaryLanguageIsoCode } = useTenantSettings()

    const getConfigurationText = useCallback(({
        mergeAssets,
        printFeatures,
        language,
        articles,
    }: IGetConfigurationTextParams) => {
        const rows: string[] = []

        articles.forEach(article => {
            rows.push(`${article.assets.length ? `${article.assets.length}x` : ''} ${getTranslation(article.articleDescriptionTranslations, language, tenantPrimaryLanguageIsoCode)}`)

            if (printFeatures[article.articleId]) {
                const tr = getTranslation(article.articleFeatures, language, tenantPrimaryLanguageIsoCode)
                if (tr) {
                    rows.push(tr)
                }
            }

            if (!mergeAssets[article.articleId]) {
                article.assets.forEach(asset => {
                    if (!asset.assetId || !asset.isFixed) return
                    rows.push([
                        asset.lmid,
                        asset.serialNumber ? `(${t(`textModal.serialNo.${language || tenantPrimaryLanguageIsoCode}`, { serialNumber: asset.serialNumber })})` : '',
                    ].filter(s => !!s).join(" "))

                    if (printFeatures[article.articleId]) {
                        const tr = getTranslation(asset.assetFeatures, language, tenantPrimaryLanguageIsoCode)
                        if (tr) {
                            rows.push(tr)
                        }
                    }
                })
            }

            rows.push("\r")

        })

        if (rows.length) {
            rows.pop()
        }

        return rows.join("\n")
    }, [t, tenantPrimaryLanguageIsoCode])

    return {
        getConfigurationText,
    }
}
